// @custom — Toaster container: renders queued toasts from the useToast store.
//
// Mount once near the root of the app (see App.jsx). Consumers trigger toasts
// with `toast(...)` or `useToast()` from '@/app/hooks/@custom/useToast'.
//
// Also mounts the VisitorTracker for first‑party analytics coverage on every
// public and app page (the tracker renders nothing).
//
// Router safety (item 8): App.jsx renders <Toaster /> inside <BrowserRouter>
// (server entry: inside <StaticRouter>), so VisitorTracker's useLocation can
// never run outside a Router — every public route is covered on mount and on
// location change.

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '../../@system/ui/toast'
import { useToast } from '@/app/hooks/@custom/useToast'
import VisitorTracker from '../VisitorTracker'

export function Toaster() {
  const { toasts } = useToast()

  return (
    <>
      <VisitorTracker />
      <ToastProvider>
        {toasts.map(({ id, title, description, action, ...props }) => (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        ))}
        <ToastViewport />
      </ToastProvider>
    </>
  )
}

export default Toaster
